// extracted by mini-css-extract-plugin
export default {"footer":"FooterSocial_footer__gDhPK","inner":"FooterSocial_inner__rE5Pu","links":"FooterSocial_links__65EMP"};